/**
 * API Configuration and Utilities
 * Client-side only untuk static export (CSR)
 */

// Base URL untuk client-side requests (exposed via NEXT_PUBLIC_ prefix)
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000/api/v1';

/**
 * Client-side fetch wrapper dengan base URL
 * Untuk static export, semua fetch dilakukan di client-side
 */
export async function clientFetch<T>(
  endpoint: string,
  options?: RequestInit
): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (!response.ok) {
    console.error('[Client Fetch] Error:', response.status, response.statusText);
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return data;
}

export async function clientPost<T>(
  endpoint: string,
  options?: RequestInit
): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    method: 'POST',
    body: options?.body,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (!response.ok) {
    console.error('[Client Fetch] Error:', response.status, response.statusText);
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return data;
}
/**
 * Type-safe API endpoints
 */
export const API_ENDPOINTS = {
  agents: '/top-agent',
  mitras: '/mitras',
  register: '/agents/register',
  // faqs: '/faqs',
  // contact: '/contact',
} as const;

/**
 * Helper function to build top-agent URL with query parameters
 */
export function buildTopAgentUrl(params: {
  period?: 'all-time' | 'today' | 'yesterday' | 'this_week' | 'this_month';
  page?: number;
  limit?: number;
  sort_by?: 'total_nilai' | 'total_tamu';
}): string {
  const searchParams = new URLSearchParams();

  if (params.period) searchParams.append('period', params.period);
  if (params.page) searchParams.append('page', params.page.toString());
  if (params.limit) searchParams.append('limit', params.limit.toString());
  if (params.sort_by) searchParams.append('sort_by', params.sort_by);

  const queryString = searchParams.toString();
  return `${API_ENDPOINTS.agents}${queryString ? `?${queryString}` : ''}`;
}

/**
 * Helper to format nilai display based on value
 * Show hidden format if > 100,000, otherwise show actual value
 */
export function formatNilai(nilaiHidden: string, nilaiAsli: string): string {
  const nilai = parseInt(nilaiAsli);

  if (isNaN(nilai)) return 'Rp 0';

  if (nilai > 100000) {
    // Show hidden format: "7x.xxx.xxx"
    return `Rp ${nilaiHidden}`;
  } else {
    // Show actual value formatted
    return `Rp ${nilai.toLocaleString('id-ID')}`;
  }
}
